export default __webpack_public_path__ + "static/media/audio-call.25624349.png";